import React from 'react';
import { Textarea } from '@roger/ui-components';
import { Loader2, Check, XCircle } from 'lucide-react';
import { useAutoSave } from '../../../hooks/useAutoSave';

interface AutoSaveCommentsProps {
  value: string;
  onSave: (newValue: string) => Promise<void>;
  placeholder?: string;
  className?: string;
  debounceDelay?: number;
}

export const AutoSaveComments: React.FC<AutoSaveCommentsProps> = ({
  value,
  onSave,
  placeholder = 'Add notes or comments...',
  className = '',
  debounceDelay = 1500,
}) => {
  const {
    value: localValue,
    setValue,
    saveStatus,
    saveNow,
  } = useAutoSave({
    initialValue: value,
    onSave,
    debounceDelay,
  });

  return (
    <div className='relative'>
      <Textarea
        value={localValue}
        onChange={e => setValue(e.target.value)}
        onBlur={saveNow}
        placeholder={placeholder}
        className={`min-h-[100px] text-sm pr-20 ${className}`}
      />
      {/* Save status indicator */}
      {saveStatus !== 'idle' && (
        <div className='absolute top-2 right-2 flex items-center gap-1 text-xs bg-white/90 px-1.5 py-0.5 rounded'>
          {saveStatus === 'saving' && (
            <span className='text-muted-foreground flex items-center gap-1'>
              <Loader2 className='h-3 w-3 animate-spin' />
              Saving...
            </span>
          )}
          {saveStatus === 'saved' && (
            <span className='text-green-600 flex items-center gap-1'>
              <Check className='h-3 w-3' />
              Saved
            </span>
          )}
          {saveStatus === 'error' && (
            <span className='text-red-500 flex items-center gap-1'>
              <XCircle className='h-3 w-3' />
              Failed
            </span>
          )}
        </div>
      )}
    </div>
  );
};
